/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/pos/types";
import TableActions from "../../../common/table/TableActions";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";

interface Props {
  posData?: Data[];
}

interface RowData {
  id: string;
  interface: string;
  POSDesc: string;
  TID: string;
}

const mapDataToTable = (pos: Data[]): RowData[] => {
  return pos.map((data) => {
    return {
      id: data.id,
      interface: data.attributes.Interface,
      POSDesc: data.attributes.POSDesc,
      TID: data.attributes.TID,
    };
  });
};

export default function PosTable({ posData }: Props) {
  const history = useHistory();
  const data = mapDataToTable(posData);

  const editAction = (rowData: RowData) => {
    history.push(`/pos/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/pos/view/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Description",
        accessorKey: "POSDesc",
      },
      { header: "Interface", accessorKey: "interface" },
      { header: "Paired With", accessorKey: "TID" },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showColumnFilters: false,
        density: "spacious",
      }}
      enableTopToolbar={false}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      manualFiltering
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="POS"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
